import gql from 'graphql-tag'

export default gql`query user_role($user_role_id: Int!){
  user_role(user_role_id: $user_role_id){
    user_role_id
    description
    permissions{
	  permission_id
      access
    }
    hourly_rates{
      role_daily_rate_id
      day_value_id
      day_value{
        day_value_id
        day_name
        abbreviated_name
      }
      hourly_rate
      date_active
    }
  }
}`